import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import Cart from './img/cart.svg';
import { useNotify } from "tailwind-notifications-react";
import { Header } from '../../header';
import { Footer } from '../../components/footer';
import { useSwipeable } from 'react-swipeable'; // Импортируем библиотеку для обработки свайпов

export const MerchDetailPage = () => {
  const [searchParams] = useSearchParams();
  const { addToCart, cartItems } = useCart();
  const [products, setProducts] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [buttonState, setButtonState] = useState(false);
  const [selectedSize, setSelectedSize] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const notify = useNotify();
  const productId = searchParams.get("id");
  const [touchPosition, setTouchPosition] = useState(0);
const [isSwiping, setIsSwiping] = useState(false);
const [showIndicators, setShowIndicators] = useState(false);
const [containerHeight, setContainerHeight] = useState("auto");


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch("https://api.alyonatestsite.store/api/products");
        if (!response.ok) {
          throw new Error("Ошибка загрузки данных");
        }
        const data = await response.json();
        setProducts(data);
      } catch (err) {
        console.log(err.message);
      }
    };
    fetchProducts();
  }, []);

  const product = products.find((p) => p.id === Number(productId));

  useEffect(() => {
    if (product) {
      document.title = `${product.name} | Магазин Алёны Швец`;
    } else {
      document.title = "Магазин Алёны Швец";
    }
  }, [product]);

  const handlers = useSwipeable({
    onSwiping: ({ deltaX }) => {
      setIsSwiping(true);
      setTouchPosition(deltaX);
    },
    onSwiped: ({ deltaX }) => {
      setIsSwiping(false);
      setTouchPosition(0);
  
      if (deltaX > 50) {
        handlePrevImage();
      } else if (deltaX < -50) {
        handleNextImage();
      }
    },
    trackTouch: true,
    trackMouse: false,
    preventScrollOnSwipe: true,
  });

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === product.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? product.images.length - 1 : prevIndex - 1
    );
  };

  if (!product) {
    return (
      <section>
        <Header page="merch" />
        <div className="flex flex-row h-screen w-full">
          <div className="relative w-[45%] h-full bg-sky-200 overflow-hidden">
            <div className="absolute top-0 left-0 h-full w-full bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
          </div>
          <div className="w-[55%] h-full flex flex-col justify-center bg-white">
            <div className="p-12">
              <div className="h-8 w-2/3 bg-sky-200 relative overflow-hidden mb-2">
                <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
              </div>
              <div className="h-6 w-1/4 bg-sky-200 relative overflow-hidden mt-4">
                <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
              </div>
              <div className="mt-12 space-y-4">
                <div className="h-5 w-full bg-sky-200 relative overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
                </div>
                <div className="h-5 w-5/6 bg-sky-200 relative overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
                </div>
                <div className="h-5 w-2/3 bg-sky-200 relative overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    );
  }

  const stockLimit = selectedSize
    ? product.sizes.find((size) => size.name === selectedSize)?.quantity
    : product.stock;

  const handleAddToCart = () => {
    if (product.sizes?.length > 0 && !selectedSize) {
      return notify({
        title: "Товар не добавлен",
        message: `Пожалуйста, выберите размер товара.`,
        type: "error",
      });
    }
    const stockLimit = selectedSize
      ? product.sizes.find((size) => size.name === selectedSize)?.quantity
      : product.stock;
    const existingItem = cartItems.find(
      (item) => item.id === product.id && item.size === selectedSize
    );
    const newQuantity = existingItem
      ? existingItem.quantity + quantity
      : quantity;
    if (newQuantity > stockLimit) {
      return notify({
        title: "Товар не добавлен",
        message: `Невозможно добавить больше товара. Доступно только ${stockLimit} шт.`,
        type: "error",
      });
    }
    addToCart(product, selectedSize, quantity);
    setButtonState(true);
    return notify({
      title: "Товар в корзине",
      message: `${product.name}${product.sizes?.length > 0 ? ` ${selectedSize}` : ''} добавлен в корзину`,
      type: "success",
    });
  };

  const handleQuantityChange = (type) => {
    if (type === "increment" && quantity < stockLimit) {
      setQuantity((prev) => prev + 1);
    } else if (type === "decrement" && quantity > 1) {
      setQuantity((prev) => prev - 1);
    }
  };

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <section className="lg:overflow-hidden">
      <Header page="merch" fixed={false} />
      <div className="flex flex-col lg:flex-row min-h-screen w-full">
      <div
    className="relative w-full lg:w-[45%] bg-black bg-opacity-60 overflow-hidden"
    {...handlers}
  >
    <div
      className="flex transition-transform duration-300"
      style={{
        transform: `translateX(${isSwiping ? touchPosition : 0}px)`,
      }}
    >
      {product.images.map((image, index) => (
        <img
          key={index}
          src={`https://api.alyonatestsite.store${image}`}
          alt={product.name}
          className={`w-full h-[500px] md:h-full object-cover shadow-2xl cursor-pointer ${
            index === currentImageIndex ? "block" : "hidden"
          }`}
          onClick={() => handleImageClick(index)}
        />
      ))}
    </div>
  </div>
        <div className="w-full lg:w-[55%] bg-white flex flex-col justify-center overflow-auto">
          <div className="p-6 lg:p-12">
            <h1 className="text-black text-3xl lg:text-5xl font-lack mb-2">
              {product.name}
            </h1>
            <div className={`${product.discount === 0 && 'hidden'} inline-flex mt-2 items-center space-x-4`}>
              <p className={`bg-sky-600 px-2 file:text-xl lg:text-2xl font-lack text-white`}>
                {product.discount} руб.
              </p>
              <p className={`font-lack text-lg lg:text-xl line-through`}>{product.price} руб.</p>
            </div>
            <p className={`${product.discount === 0 ? 'flex' : 'hidden'} text-xl lg:text-2xl font-lack text-black mt-2`}>
              {product.price} руб.
            </p>
            <p className="text-sm lg:text-lg font-lack text-gray-600 mt-6 lg:mt-12">
              Описание
            </p>
            <p className="text-lg lg:text-xl font-lack text-black w-5/6 mt-2 lg:mt-2 whitespace-pre-line">
              {product.description}
            </p>
            <p className="text-sm lg:text-lg font-lack text-gray-600 mt-4 lg:mt-6">
              Состав
            </p>
            <p className="text-lg lg:text-xl font-lack text-black mt-2 lg:mt-2">
              {product.produced}
            </p>
            {product.sizes?.length > 0 && (
              <div className="mt-6 lg:mt-12">
                <p className="text-sm lg:text-lg font-lack text-gray-600 mb-4">Выберите товар</p>
                <div className="flex flex-wrap gap-4">
                  {product.sizes.map((size) => (
                    <button
                      key={size.name}
                      onClick={() => size.quantity > 0 && setSelectedSize(size.name)}
                      disabled={size.quantity === 0}
                      className={`px-4 py-2 rounded border text-sm lg:text-lg font-lack transition-colors duration-300 ${size.quantity > 0
                          ? selectedSize === size.name
                            ? "bg-sky-500 text-white border-sky-500"
                            : "bg-white text-black border-gray-300 hover:bg-sky-100"
                          : "bg-gray-300 text-gray-500 cursor-not-allowed"
                        }`}
                    >
                      {size.name}
                    </button>
                  ))}
                </div>
              </div>
            )}
            <div className={`${product.sizes?.length > 0 & !selectedSize ? 'hidden' : 'flex'} mt-6 items-center space-x-4`}>
              <button
                onClick={() => handleQuantityChange("decrement")}
                className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400"
                disabled={quantity === 1}
              >
                -
              </button>
              <p className="text-lg font-bold">{quantity}</p>
              <button
                onClick={() => handleQuantityChange("increment")}
                className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400"
                disabled={quantity === stockLimit}
              >
                +
              </button>
            </div>
            <div className="flex flex-row space-x-4">
              <button
                onClick={handleAddToCart}
                className={`mt-6 lg:mt-12 px-6 py-3 rounded w-full lg:w-1/4 ${buttonState
                    ? "bg-green-500 text-white"
                    : "bg-sky-500 text-white"
                  }`}
              >
                {buttonState ? "Добавить ещё" : "Добавить в корзину"}
              </button>
              <a
                href="/merch/cart"
                className={`${buttonState ? 'flex' : 'hidden'} mt-6 lg:mt-12 px-6 py-3 rounded bg-gray-300`}
              >
                Перейти к корзине
              </a>
            </div>
            <div className="mt-8 p-4 rounded-2xl font-lack bg-sky-400 bg-opacity-30">
            Обратите внимание, что сбор и доставка товара может занимать от 2 до 4 недель. Вопросы касаемо заказов можно задать в нашей <a href="https://t.me/alyonashvetsmerch_bot" rel="noreferrer" target="_blank" className="text-sky-600 hover:text-sky-400 hover:underline cursor-pointer">технической поддержке</a>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          onClick={handleModalClose}
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 cursor-pointer"
        >
          <div
            className="relative w-full h-3/4 flex flex-col items-center justify-center z-80 pointer-events-none"
          >
            <img
              src={`https://api.alyonatestsite.store${product.images[currentImageIndex]}`}
              alt={product.name}
              className="max-w-full max-h-full pointer-events-auto"
            />
            <div className="flex mt-4 space-x-2 pointer-events-auto"> {}
              {product.images.map((image, index) => (
                <img
                  key={index}
                  src={`https://api.alyonatestsite.store${image}`}
                  alt={product.name}
                  className={`w-16 h-16 object-cover cursor-pointer ${index === currentImageIndex ? "border-2 border-sky-500" : ""
                    }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentImageIndex(index);
                  }}
                />
              ))}
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handlePrevImage();
              }}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black text-white rounded-full p-2 pointer-events-auto"
            >
              &larr;
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleNextImage();
              }}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black text-white rounded-full p-2 pointer-events-auto"
            >
              &rarr;
            </button>
          </div>
        </div>
      )}
      <a
        href="/merch/cart"
        className="z-40 cursor-pointer fixed bottom-10 right-10 bg-sky-400 text-white rounded-full p-5 lg:p-8 shadow-lg hover:bg-sky-600 transition duration-300"
      >
        <img
          src={Cart}
          className="w-6 h-6"
          alt="cart"
        />
      </a>
      <Footer />
    </section>
  );
};